import { createFileRoute } from "@tanstack/react-router";
import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageBreadcrumbs from "@/components/PageBreadcrumbs";

export const Route = createFileRoute("/_portal/handbook")({
  component: UserHandbook,
});

function UserHandbook() {
  const { t } = useTranslation();
  const crumbsRef = useRef<HTMLDivElement | null>(null);
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!ref.current) return;
    const iframe = document.getElementById("handbook") as HTMLIFrameElement;
    const topCover = document.getElementById(
      "iframe-top-cover",
    ) as HTMLDivElement;

    // The iframe and its top cover are positioned globally, so both are pushed
    // down by the breadcrumb's height and the iframe is shortened to match.
    const crumbsOffset = () =>
      ref.current && crumbsRef.current
        ? ref.current.getBoundingClientRect().top -
          crumbsRef.current.getBoundingClientRect().top
        : 0;
    const applyOffset = (offset: number) => {
      // When the mobile tab bar (see BottomTabBar) is on the page, it covers the
      // bottom. Check for it rather than a width, so the two cannot drift apart.
      const tabBar = document.querySelector("[data-tab-bar]")
        ? " - 56px - env(safe-area-inset-bottom)"
        : "";
      iframe.style.height = `calc(100% - ${offset}px${tabBar})`;
      topCover.style.marginTop = `${offset}px`;
    };

    const boundingRect = ref.current.getBoundingClientRect();
    iframe.style.top = boundingRect.top + "px";
    iframe.style.left = boundingRect.left + "px";
    iframe.style.width = boundingRect.width + "px";
    applyOffset(crumbsOffset());
    iframe.classList.remove("hide");
    topCover.classList.remove("hide");

    const obs = new ResizeObserver(() => {
      if (!ref.current) return;

      const boundingRect = ref.current.getBoundingClientRect();
      const offset = crumbsOffset();

      if (window.innerWidth <= 768) {
        // HACK: 87px is the height of the header on mobile
        iframe.style.top = 87 + offset + "px";
      }
      iframe.style.left = boundingRect.left + "px";
      if (boundingRect.width >= 1998) {
        topCover.style.left = boundingRect.x + 1830 + "px";
      } else {
        topCover.style.left = "";
      }
      iframe.style.width = boundingRect.width + "px";
      applyOffset(offset);
    });
    obs.observe(ref.current);
    // A breadcrumb that wraps (long label, late translations) changes the offset.
    if (crumbsRef.current) obs.observe(crumbsRef.current);
    return () => {
      iframe.classList.add("hide");
      topCover.classList.add("hide");
      topCover.style.left = "";
      iframe.style.height = "";
      topCover.style.marginTop = "";
      obs.disconnect();
    };
  }, []);
  return (
    <>
      <div ref={crumbsRef}>
        <PageBreadcrumbs
          levels={[{ label: t("SIDEBAR.INFO"), path: "/handbook" }]}
        />
      </div>
      <div ref={ref} className="iframe-wrapper"></div>
    </>
  );
}
